import React from 'react';
import PropTypes from 'prop-types';
import className from '../style.module.scss';
import {StartButton, BTN_STATUS} from '../TimerImages';
import {composeTime, splitTime} from '../Timer.utils';

/**
 * StartTimer
 *  - Image button to Start Timer
 */
export function StartTimer(props) {
  const [status, setStatus] = React.useState(BTN_STATUS.DEFAULT);

  const notDisabled = () => !props.disabled;

  React.useEffect(() => {
    if (notDisabled()) setStatus(BTN_STATUS.DEFAULT);
    else setStatus(BTN_STATUS.DISABLED);
  }, [props.disabled]);

  const onReset = () => notDisabled() && setStatus(BTN_STATUS.DEFAULT);

  const onHover = () => notDisabled() && setStatus(BTN_STATUS.HOVER);

  const onPress = () => notDisabled() && setStatus(BTN_STATUS.CLICK);

  const onClick = () => notDisabled() && props.startTimer();

  return (
    <StartButton
      status={status}
      onClick={onClick}
      onMouseUp={onReset}
      onMouseDown={onPress}
      onMouseEnter={onHover}
      onMouseLeave={onReset}
      className={className.startButton}
    />
  );
}

StartTimer.propTypes = {
  /**
   * Callback for onClick
   */
  startTimer: PropTypes.func,
  /**
   * Boolen to disable button
   */
  disabled: PropTypes.bool,
};
